import { render, staticRenderFns } from "./wy-customer-overview-panel-conversations-by-devices.vue?vue&type=template&id=583700a8&"
import script from "./wy-customer-overview-panel-conversations-by-devices.vue?vue&type=script&lang=js&"
export * from "./wy-customer-overview-panel-conversations-by-devices.vue?vue&type=script&lang=js&"
import style0 from "./wy-customer-overview-panel-conversations-by-devices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports